import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import * as fromAppRoot from '@app/app.reducers';

@Injectable({
  providedIn: 'root'
})
class CrowdInvestorGuardService {
  constructor(
    private router: Router,
    private store: Store
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Observable((observer) => {
      this.store.pipe(take(3), select(fromAppRoot.selectCustomer)).subscribe((value) => {
        if (!value.id && !value.email) {
          return;
        }

        if (!value.has_crowd_investor_account) {
          observer.next(this.router.parseUrl('/'));
        }
        observer.next(true);
      });
    });
  }
}

export const CrowdInvestorGuard: CanActivateFn = () => {
  return inject(CrowdInvestorGuardService).canActivate();
};
